import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsMarketingPreferencesForm {
  marketingPreferenceEmailField: FormField;
  marketingPreferenceFieldset: FormFieldset;
  marketingPreferencePostField: FormField;
  marketingPreferenceTelephoneField: FormField;
}
